<template>
  <b-overlay :show="isLoading">
    <div class="users-shell">
      <div class="users-header">
        <div>
          <p class="eyebrow mb-25">สรุปยอดผู้เล่น</p>
          <h4 class="mb-0">สถานะสมาชิกและการใช้งาน</h4>
        </div>
        <span class="updated-pill">
          <i class="far fa-clock" />
          {{ now }}
        </span>
      </div>

      <div class="users-highlight">
        <div class="highlight-icon">
          <i class="fas fa-users" />
        </div>
        <div>
          <span>สมาชิกทั้งหมด</span>
          <h2 class="mb-0">{{ formatInt(getTotal('totalRegisterMembers')) }}</h2>
        </div>
        <div class="highlight-active">
          <small>Active วันนี้</small>
          <strong>{{ formatInt(data ? data.activeNew : 0) }}</strong>
        </div>
      </div>

      <div class="users-grid">
        <div
          v-for="item in userStats"
          :key="item.key"
          class="user-stat-card"
          :class="`stat-${item.color}`"
        >
          <span class="stat-icon">
            <i :class="item.icon" />
          </span>
          <div class="stat-content">
            <h5 class="mb-0">{{ formatInt(item.value) }}</h5>
            <small>{{ item.label }}</small>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import moment from 'moment-timezone'
import {
  BOverlay,
} from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
  },
  data() {
    return {
      isLoading: false,
      data: null,
      now: moment.tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm'),
    }
  },
  mounted() {
    this.getData('USERS')
  },
  computed: {
    userStats() {
      return [
        {
          key: 'today-register',
          label: 'สมาชิกใหม่ (วันนี้)',
          value: this.getTotal('todayRegisterMembers'),
          icon: 'fas fa-user-plus',
          color: 'success',
        },
        {
          key: 'no-deposit',
          label: 'สมาชิกที่ยังไม่ฝากเงิน',
          value: this.getTotal('totalNoDepositMembers'),
          icon: 'fas fa-user-clock',
          color: 'warning',
        },
        {
          key: 'today-no-dep',
          label: 'สมาชิกใหม่ที่ยังไม่ฝาก (วันนี้)',
          value: this.getTotal('todayNoDepMembers'),
          icon: 'fas fa-user-slash',
          color: 'dark',
        },
        {
          key: 'deposit-members',
          label: 'สมาชิกที่ฝากเงินแล้ว',
          value: this.getTotal('totalDepositMembers'),
          icon: 'fas fa-user-check',
          color: 'danger',
        },
        {
          key: 'first-deposit',
          label: 'สมาชิกใหม่ฝากแรก (วันนี้)',
          value: this.data ? this.data.depfirst_count : 0,
          icon: 'fas fa-bolt',
          color: 'primary',
        },
        {
          key: 'active',
          label: 'ยอด Active (วันนี้)',
          value: this.data ? this.data.activeNew : 0,
          icon: 'fas fa-heartbeat',
          color: 'pink',
        },
      ]
    },
  },
  methods: {
    getTotal(key) {
      return this.data && this.data[key] ? this.data[key].total : 0
    },
    formatInt(value) {
      return Number(value || 0).toLocaleString('en-US')
    },
    async getData(type) {
      this.isLoading = true
      try {
        const { data } = await this.$http.get(`/dashboard?type=${type}`)

        this.data = data
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.users-shell {
  position: relative;
  height: 100%;
  padding: 18px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(34, 41, 47, 0.06);
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.04);
  overflow: hidden;
}

.users-shell::before {
  content: '';
  position: absolute;
  top: -78px;
  left: -96px;
  width: 230px;
  height: 230px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(115, 103, 240, 0.13), rgba(115, 103, 240, 0));
  pointer-events: none;
}

.users-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.eyebrow {
  color: #8b93a7;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.users-header h4 {
  color: #283046;
  font-size: 1.05rem;
  font-weight: 800;
}

.updated-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(115, 103, 240, 0.1);
  color: #5e50ee;
  font-size: 0.72rem;
  font-weight: 800;
  white-space: nowrap;
}

.users-highlight {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f1efff 0%, #ece9ff 55%, #f7f5ff 100%);
  color: #3f35a8;
  border: 1px solid rgba(115, 103, 240, 0.12);
  box-shadow: 0 14px 30px rgba(115, 103, 240, 0.1);
  margin-bottom: 14px;
}

.highlight-icon {
  width: 54px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: rgba(115, 103, 240, 0.12);
  font-size: 1.4rem;
  color: #7367f0;
}

.users-highlight span,
.highlight-active small {
  display: block;
  opacity: 0.8;
  font-size: 0.78rem;
  font-weight: 700;
}

.users-highlight h2 {
  font-weight: 900;
  font-size: 1.8rem;
  letter-spacing: -0.4px;
}

.highlight-active {
  text-align: right;
  padding-left: 16px;
  border-left: 1px solid rgba(115, 103, 240, 0.16);
}

.highlight-active strong {
  font-size: 1.2rem;
  font-weight: 900;
}

.users-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.user-stat-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 14px;
  background: #fbfcff;
  border: 1px solid rgba(34, 41, 47, 0.06);
  overflow: hidden;
}

.user-stat-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--stat-bg);
  opacity: 0.9;
  pointer-events: none;
}

.stat-icon,
.stat-content {
  position: relative;
  z-index: 1;
}

.stat-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: var(--stat-color);
  box-shadow: 0 6px 14px var(--stat-shadow);
}

.stat-content h5 {
  font-size: 1rem;
  font-weight: 900;
  color: #283046;
}

.stat-content small {
  display: block;
  color: #8b93a7;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.25;
}

.stat-success { --stat-color: linear-gradient(135deg, #28c76f, #48da89); --stat-shadow: rgba(40, 199, 111, 0.24); --stat-bg: linear-gradient(135deg, rgba(40, 199, 111, 0.07), rgba(40, 199, 111, 0)); }
.stat-warning { --stat-color: linear-gradient(135deg, #ff9f43, #ffb976); --stat-shadow: rgba(255, 159, 67, 0.24); --stat-bg: linear-gradient(135deg, rgba(255, 159, 67, 0.08), rgba(255, 159, 67, 0)); }
.stat-dark { --stat-color: linear-gradient(135deg, #4b5563, #7b8390); --stat-shadow: rgba(75, 85, 99, 0.2); --stat-bg: linear-gradient(135deg, rgba(75, 85, 99, 0.06), rgba(75, 85, 99, 0)); }
.stat-danger { --stat-color: linear-gradient(135deg, #ea5455, #ff7b7c); --stat-shadow: rgba(234, 84, 85, 0.24); --stat-bg: linear-gradient(135deg, rgba(234, 84, 85, 0.07), rgba(234, 84, 85, 0)); }
.stat-primary { --stat-color: linear-gradient(135deg, #7367f0, #9e95f5); --stat-shadow: rgba(115, 103, 240, 0.24); --stat-bg: linear-gradient(135deg, rgba(115, 103, 240, 0.07), rgba(115, 103, 240, 0)); }
.stat-pink { --stat-color: linear-gradient(135deg, #ec407a, #f48fb1); --stat-shadow: rgba(236, 64, 122, 0.24); --stat-bg: linear-gradient(135deg, rgba(236, 64, 122, 0.07), rgba(236, 64, 122, 0)); }

@media (max-width: 575.98px) {
  .users-highlight {
    grid-template-columns: auto 1fr;
  }

  .highlight-active {
    grid-column: 1 / -1;
    text-align: left;
    padding-left: 0;
    padding-top: 10px;
    border-left: 0;
    border-top: 1px solid rgba(115, 103, 240, 0.16);
  }

  .users-grid {
    grid-template-columns: 1fr;
  }
}
</style>
